import styled from "styled-components";

export const TherapistsTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: ${p => p.small ? '20px' : '34px'};
  font-weight: 600;
  line-height: normal;
  color: ${p => p.theme.palette.colors.text};
`;

export const TherapistsContainer = styled.div.attrs({})`
  padding: 40px clamp(18px, 3vw, 40px);
  display: flex;
  gap: 24px;
  flex-direction: column;
  @media (max-width: 502px) {
    padding: 16px;
  }
`;


export const TherapistsHeader = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export const TherapistsBody = styled.div.attrs({})`
  padding: 24px;
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 24px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 23.5px;
  box-shadow: 0 24px 56px ${p => p.theme.palette.colors.shadowStrong};
  
`;
export const Container = styled.div.attrs({})`
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  padding: 16px 24px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 502px) {
    padding: 16px;
  }
`;

export const ProfilePhotoSection = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 28px;
  padding: 8px 0 20px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`;

export const ProfilePhotoFrame = styled.div.attrs({})`
  position: relative;
  width: 184px;
  min-width: 184px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  padding: 7px;
  background: ${p => p.theme.palette.blue.main};
  box-shadow:
    0 20px 48px ${p => p.theme.palette.colors.shadowStrong},
    inset 0 1px 0 ${p => p.theme.palette.colors.light};

  @media (max-width: 767px) {
    width: 160px;
    min-width: 160px;
  }
`;

export const ProfilePhotoInner = styled.div.attrs({})`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  background:
    radial-gradient(circle at 32% 26%, ${p => p.theme.palette.colors.surfaceElevated} 0%, ${p => p.theme.palette.colors.backgroundStrong} 72%);
  position: relative;
`;

export const ProfilePhotoImage = styled.div.attrs({})`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: ${p => p.image ? `url(${p.image}) no-repeat center center / cover` : 'transparent'};
`;

export const ProfilePhotoFallback = styled.div.attrs({})`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Gilroy;
  font-size: 54px;
  font-weight: 700;
  letter-spacing: -0.04em;
  color: ${p => p.theme.palette.colors.text};
  background:
    radial-gradient(circle at 30% 28%, ${p => p.theme.palette.colors.surfaceElevated} 0%, ${p => p.theme.palette.colors.backgroundStrong} 74%);
`;

export const ProfilePhotoAction = styled.div.attrs({})`
  position: absolute;
  right: -2px;
  bottom: 20px;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  border: 6px solid ${p => p.theme.palette.colors.backgroundStrong};
  background: ${p => p.theme.palette.blue.main};
  box-shadow: 0 14px 34px ${p => p.theme.palette.colors.shadowStrong};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.04);
  }

  @media (max-width: 767px) {
    width: 60px;
    height: 60px;
  }
`;

export const ProfilePhotoActionIcon = styled.img.attrs({
  src: '/icons/cam.svg',
  alt: 'camera icon',
})`
  width: 28px;
  height: 28px;
`;

export const ProfilePhotoCopy = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 520px;
`;

export const ProfilePhotoTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: ${p => p.theme.palette.colors.text};
`;

export const ProfilePhotoText = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 14px;
  line-height: 1.65;
  color: ${p => p.theme.palette.colors.muted};
`;

export const TherapistsContent = styled.div.attrs({})`
  background: ${p => p.theme.palette.colors.surfaceElevated};
  padding: 16px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;
  &:hover{
    transform: scale(1.02);
    transition: 0.4s;
  }
`;

export const DiaryTitle = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  color:${p => p.theme.palette.colors.text};
`;

export const DiaryText = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: ${p => p.theme.palette.colors.muted};
  display: flex;
  justify-content: space-between;
  gap: 24px;
`;

export const ConsultationDate = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${p => p.theme.palette.colors.badgeMuted};
  padding: 2px 8px;
  align-self: flex-start;
  border-radius: 4px;
`;
export const DateText = styled.span.attrs({})`
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight:${p => p.bold ? "600;" : "500;"};
  color: ${p => p.theme.palette.colors.text};
`;
export const FormBorder = styled.div.attrs({})`
  border-top: 1px solid  ${p => p.theme.palette.colors.borderSoft};
`;
